export default __webpack_public_path__ + "static/favicon2-8ddf62dab83d00152698e9d6e25daabd.ico";